import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import AuthContext from 'context/autentication/authContext';
import VariableContext from 'context/variable/variableContext';

////////// estilos ///////////////
const useStyles = makeStyles((theme) => ({
  formControl: {
    width: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

export default function SelectorSubGrupos(props) {
  ////////// estilos ///////////////
  const classes = useStyles();

  ///////////////// variables ////////////////
  const variableContext = useContext(VariableContext);
    const { variables,obtenerVariables} = variableContext;
  const [age, setAge] = useState('');
  

  const authContext = useContext(AuthContext);
  const { autenticado, cliente, usuario } = authContext;


  const handleChange = (event) => {
    props.func(null);
    const a = event.target.value
    setAge(a)
    
    props.func(a);
  };


  ////////////////////////////////////  ///////

  ////////// funciones ///////////////
  useEffect(() => {
    if (props?.elegido?.id) {
      obtenerVariables({dispositivo: props.elegido.id}) 
    }  
    // eslint-disable-next-line
  }, []);

  

  return (
    <div>
      <FormControl variant="outlined" className={classes.formControl}>
        <InputLabel id="variables">Variables</InputLabel>
        { props.subGrupos ?
          <Select
            labelId="variables"
            id="variables"
            value={age.nombre}
            onChange={handleChange}
            label="variables"
          >
              {props.subGrupos.length === 0 ?
                <MenuItem value="">
                  <em>Dispositivo sin variables creadas</em>
                </MenuItem>
                : 
                props.subGrupos.map((g) => (
                  <MenuItem value={g}>{g.nombre}</MenuItem>
                ))}
          </Select>
        :
        <Select
            disabled
            labelId="grupo"
            id="grupo"
            label="grupo"
          >
          </Select>
      }
      </FormControl>

    </div>
  );
};


